import axiosInstance from "@/config/axiosInstance";

//Registration (authentication endpoints)
export const getRegistrationOptions = async (friendlyName) => {
    const res = await axiosInstance.post("/api/auth/passkey/register/options",
        { friendlyName }
    );
    return res.data.data;
};

export const verifyRegistration = async ({ credential, friendlyName }) => {
    const res = await axiosInstance.post("/api/auth/passkey/register/verify",
        { credential, friendlyName }
    );
    return res.data.data;
};

// Authentication (public endpoints)
export const getAuthenticationOptions = async () => {
    const res = await axiosInstance.post("/api/auth/passkey/login/options");
    return res.data.data;
};

export const verifyAuthentication = async (credential) => {
    const res = await axiosInstance.post("/api/auth/passkey/login/verify",
        { credential }
    );
    return res.data;
};

// Credential management (authenticated endpoints)
export const getUserPasskeys = async () => {
    const res = await axiosInstance.get("/api/auth/passkey/credentials");
    return res.data.data;
};

export const deletePasskey = async (id) => {
    const res = await axiosInstance.delete(`/api/auth/passkey/credentials/${id}`);
    return res.data;
};

export const renamePasskey = async ({ id, friendlyName }) => {
    const res = await axiosInstance.patch(
        `/api/auth/passkey/credentials/${id}`,
        { friendlyName }
    );
    return res.data;
};